import { UseApiCallV2 } from "hooks";
import { getActiveUrlsBasedOnRoute } from "./helpers";
import { useReactQueryV2 } from "hooks/use-react-query-v2";

export function usePreviewHistoryApi({ pathname, fileId, sportName }) {
  const { url1, url2, url3 } = getActiveUrlsBasedOnRoute({
    pathname,
    sportName,
  });

  const {
    data: videoDetails,
    isLoading: videoDetailsDataLoading,
    error: videoDetailsDataError,
  } = useReactQueryV2({
    url: url1,
    method: "POST",
    paramsData: {
      fileid: fileId,
    },
    skip: !fileId,
    queryKey: [url1, fileId],
  });

  const {
    data: PValueImages,
    isLoading: PValueImagesLoading,
    error: PValueImagesError,
  } = useReactQueryV2({
    url: url2,
    method: "POST",
    paramsData: {
      fileid: fileId,
    },
    skip: !fileId,
    queryKey: [url2, fileId],
  });

  const {
    data: tracerImageData,
    isLoading: tracerImageLoading,
    error: tracerImageError,
  } = useReactQueryV2({
    url: url3,
    method: "POST",
    paramsData: {
      fileid: fileId,
    },
    skip: !fileId,
    queryKey: [url3, fileId],
  });

  return {
    videoDetails,
    videoDetailsDataLoading,
    PValueImages,
    PValueImagesLoading,
    tracerImageData,
    tracerImageLoading,
  };
}
